import { Box, type BoxProps, Radio, Text, Title } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import { useTranslation } from '@flecto/translations'

import { useTaxProfileFormContext } from '../TaxesFormProvider/TaxesFormProvider'

export function TaxesPriceSettingsSection(props: PropsWithChildren<BoxProps>) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_taxes' })
  const form = useTaxProfileFormContext()

  return (
    <Box {...props}>
      <Title order={4}>{t('taxes_price_settings_section.title')}</Title>
      <Text color='dimmed'>
        {t('taxes_price_settings_section.description')}
      </Text>
      <Radio.Group
        mt='md'
        name='show_prices_with_tax'
        value={form.values.show_prices_with_tax ? '1' : '0'}
        onChange={(value) => {
          if (value === '1') {
            form.setFieldValue('show_prices_with_tax', true)
          } else {
            form.setFieldValue('show_prices_with_tax', false)
          }
        }}
      >
        <Radio
          my='sm'
          value='1'
          label={t(
            'taxes_price_settings_section.show_prices_with_tax.label_true'
          )}
          description={t(
            'taxes_price_settings_section.show_prices_with_tax.description_true'
          )}
        />
        <Radio
          value='0'
          label={t(
            'taxes_price_settings_section.show_prices_with_tax.label_false'
          )}
          description={t(
            'taxes_price_settings_section.show_prices_with_tax.description_false'
          )}
        />
      </Radio.Group>
    </Box>
  )
}
